import { Slider } from "@components/atoms/Slider"
import { cn, tv } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "CTA Cards",
  category: "layouts",
  icon: "slides",
  description: "A row of CTA cards",
  keywords: ["category", "genre", "tile"],
  tags: ["#homepage", "#featured"],
  flags: {
    fullWidth: true,
    marginRule: "featured-card",
  },
}

export default defineBlock("content/cta-cards", (props) => {
  return (
    <div className={cn(!env.admin && createStyles({ theme: props.theme ?? "grey" }))}>
      <InnerBlocks
        orientation="horizontal"
        allowedBlocks={["content/cta-cards-item"]}
        template={[
          ["content/cta-cards-item", {}],
          ["content/cta-cards-item", {}],
          ["content/cta-cards-item", {}],
        ]}
        templateLock="all"
        adminClassName="w-grid mx-auto grid grid-cols-1 md:grid-cols-3 gap-5"
      />
    </div>
  )
})

const createStyles = tv({
  base: "w-grid mx-auto grid grid-cols-1 md:grid-cols-3 gap-5",
  variants: {
    theme: {
      orange: "[&_.card-item]:bg-orange [&_.card-item]:text-black",
      grey: "[&_.card-item]:bg-bg-mid [&_.card-item:hover]:bg-neutral-700 [&_.card-item]:text-white",
      white: "[&_.card-item]:bg-white [&_.card-item:hover]:bg-neutral-100 [&_.card-item]:text-black",
    },
  },
})
